import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderToday: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="calender-today"><path fillRule="evenodd" clipRule="evenodd" d="M3 6.75C3 4.67893 4.67893 3 6.75 3H17.25C19.3211 3 21 4.67893 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75ZM19.5 8H4.5V17.25C4.5 18.4926 5.50736 19.5 6.75 19.5H17.25C18.4926 19.5 19.5 18.4926 19.5 17.25V8ZM9.5 13.75C9.5 12.3693 10.6193 11.25 12 11.25C13.3807 11.25 14.5 12.3693 14.5 13.75C14.5 15.1307 13.3807 16.25 12 16.25C10.6193 16.25 9.5 15.1307 9.5 13.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCalenderToday;
